// Totaux calculés SUR L'APPAREIL, à chaque enregistrement, sans réseau (mêmes fonctions que le serveur et que l'export Excel/PDF).
import type { TotauxLocaux, TotauxCpnLocaux } from '../../../shared/business-logic/calculLocal.ts';
import { TRANCHES_CPN1 } from '../../../shared/business-logic/cpn.ts';

const Avertissements = ({ liste }: { liste: string[] }) => liste.length === 0 ? null : (
  <div className="messages-erreur" role="status">
    <strong>Attention — lignes non comptées :</strong>
    <ul>{liste.map((a, i) => <li key={i}>{a}</li>)}</ul>
  </div>
);

export function TotauxRceEnDirect({ totaux, refuses }: { totaux: TotauxLocaux; refuses: number }) {
  const avert = [...totaux.avertissements];
  if (refuses > 0) avert.push(`${refuses} saisie(s) refusée(s) par le serveur : non comptée(s) tant qu'elles ne sont pas corrigées.`);
  return (
    <details className="carte" style={{ margin: '0 0 14px' }} aria-label="Totaux en direct">
      <summary>📊 Totaux en direct (calculés sur cet appareil) — {totaux.nbSaisies} saisie(s), {totaux.totalCE} cas</summary>
      <p className="note">Mis à jour à chaque enregistrement, même sans connexion. Identiques au RMA exporté (Excel / PDF).</p>
      <table>
        <thead><tr><th>Indicateur</th><th>Total</th></tr></thead>
        <tbody>
          <tr><td>Total consultations externes</td><td>{totaux.totalCE}</td></tr>
          <tr><td>— moins de 5 ans</td><td>{totaux.ceMoins5ans}</td></tr>
          <tr><td>— 5 ans et plus</td><td>{totaux.ce5ansEtPlus}</td></tr>
          <tr><td>Cas de fièvre</td><td>{totaux.totalFievre}</td></tr>
          <tr><td>Paludisme (diagnostics)</td><td>{totaux.totalPaludisme}</td></tr>
        </tbody>
      </table>
      <table>
        <thead><tr><th>Paludisme — tranche</th><th>Fièvre</th><th>TDR fait</th><th>TDR +</th><th>ACT</th><th>Artes.</th></tr></thead>
        <tbody>
          {totaux.palu.map((l) => (
            <tr key={l.tranche}><td>{l.tranche}</td><td>{l.casFievre}</td><td>{l.tdrEffectue}</td><td>{l.positifs}</td><td>{l.traitesACT}</td><td>{l.traitesArtesunate}</td></tr>
          ))}
        </tbody>
        <tfoot><tr style={{ fontWeight: 700 }}><td>Total</td><td>{totaux.totalPaluTranches}</td><td>{totaux.palu.reduce((a, l) => a + l.tdrEffectue, 0)}</td><td>{totaux.palu.reduce((a, l) => a + l.positifs, 0)}</td><td>{totaux.palu.reduce((a, l) => a + l.traitesACT, 0)}</td><td>{totaux.palu.reduce((a, l) => a + l.traitesArtesunate, 0)}</td></tr></tfoot>
      </table>
      <Avertissements liste={avert} />
    </details>
  );
}

export function TotauxCpnEnDirect({ totaux, refuses }: { totaux: TotauxCpnLocaux; refuses: number }) {
  const r = totaux.resultat;
  const avert: string[] = [];
  if (totaux.ageManquant) avert.push(`${totaux.ageManquant} saisie(s) sans âge exploitable : non ventilée(s) par tranche d'âge.`);
  if (refuses > 0) avert.push(`${refuses} saisie(s) refusée(s) par le serveur : non comptée(s) tant qu'elles ne sont pas corrigées.`);
  return (
    <details className="carte" style={{ margin: '0 0 14px' }} aria-label="Totaux CPN en direct">
      <summary>📊 Totaux CPN en direct (calculés sur cet appareil) — {r.totalCpn} femme(s)</summary>
      <p className="note">Mis à jour à chaque enregistrement, même sans connexion. Identiques au RMA exporté (Excel / PDF).</p>
      <table>
        <tbody>
          <tr><td>Total CPN</td><td>{r.totalCpn}</td></tr>
          <tr><td>1ère CPN</td><td>{r.premiereCpn.total}</td></tr>
          {TRANCHES_CPN1.map((t) => <tr key={t}><td>— {t}</td><td>{r.premiereCpn.parTranche[t] ?? 0}</td></tr>)}
          <tr><td>CPN précoce (&lt; 4 mois)</td><td>{r.premiereCpn.precoce}</td></tr>
          <tr><td>Total femme enceinte 1ère CPN reçu FAF</td><td>{r.suivi.cpn1Mms}</td></tr>
          <tr><td>Total femme enceinte reçu au moins 30 cp MMS/FAF</td><td>{r.suivi.mmsAu30}</td></tr>
          <tr><td>4 CPN et plus</td><td>{r.suivi.cpn4EtPlus}</td></tr>
          <tr><td>TPI1 / TPI2 / TPI3 / TPI4+</td><td>{r.tpiEtMid.tpi1} / {r.tpiEtMid.tpi2} / {r.tpiEtMid.tpi3} / {r.tpiEtMid.tpi4EtPlus}</td></tr>
          <tr><td>Td1 / Td2+</td><td>{r.td.td1} / {r.td.td2EtPlus}</td></tr>
        </tbody>
      </table>
      <Avertissements liste={avert} />
    </details>
  );
}
